import { Navigate, Outlet, useLocation } from 'react-router';
import { CarregandoTelaCheia } from '@/componentes/CarregandoTriplice';
import { CAMINHO_TROCAR_SENHA, useAuth } from '@/lib/auth';

/**
 * Bloqueia as rotas autenticadas.
 *
 * Enquanto `carregando` (refresh silencioso + `GET /auth/sessao`), mostra o loader da marca:
 * redirecionar aqui mandaria para o login quem tem cookie de refresh válido — o F5 deslogaria.
 * É tela cheia e não `Skeleton` porque neste instante não há forma a prever: não se sabe nem se a
 * próxima tela é o painel ou o login (docs/CONVENCOES-UI.md, §Estados de tela).
 *
 * Ao mandar para `/entrar`, guarda em `state.de` a rota pretendida, para voltar depois do login.
 * Não existe tela de conta bloqueada: a empresa é uma só e não há multi-tenant.
 */
export function RotaProtegida() {
  const { autenticado, carregando, usuario } = useAuth();
  const local = useLocation();

  if (carregando) return <CarregandoTelaCheia rotulo="Verificando sua sessão…" />;
  if (!autenticado) {
    return <Navigate to="/entrar" replace state={{ de: local.pathname + local.search }} />;
  }
  // 🚨 Senha nova obrigatória (regra 24, 1.8): **toda** rota protegida cai na tela bloqueante, e nenhuma
  // outra abre antes. O servidor faz o mesmo (403 em tudo menos a troca), então isto é a tela acompanhando
  // a tranca, não a tranca.
  if (usuario?.exigirNovaSenha && local.pathname !== CAMINHO_TROCAR_SENHA) {
    return <Navigate to={CAMINHO_TROCAR_SENHA} replace />;
  }
  return <Outlet />;
}
